export default __webpack_public_path__ + "static/media/18.b55bb0c6.png";